var moment = require('moment')

function getRewardValue (reward) {
  return Number(reward.rewardValue || reward.noteType || 0)
}

function getRewardQuantity (reward) {
  return Number(reward.totalQuantity || reward.noteAmount || 0)
}

function getRewardLabel (reward) {
  if (reward.rewardLabel && reward.rewardLabel.length > 0) {
    return reward.rewardLabel
  }
  let rewardValue = getRewardValue(reward)
  return rewardValue > 0 ? 'RM ' + rewardValue : ''
}

function recalculateRewardPoolTotal (state) {
  state.sumOfAllNotes = 0
  for (let i = 0; i < state.customRMAmount.length; i++) {
    let rewardValue = getRewardValue(state.customRMAmount[i])
    let rewardQuantity = getRewardQuantity(state.customRMAmount[i])
    if (rewardQuantity > 0) {
      state.sumOfAllNotes = Number(state.sumOfAllNotes) + Number(rewardValue * rewardQuantity)
    }
  }
}

function normalizeLensIndex (lensIndex) {
  if (lensIndex === undefined || lensIndex === null) {
    return ''
  }

  let value = String(lensIndex).trim()
  if (value.length === 0) {
    return ''
  }

  let numericValue = Number(value)
  return isNaN(numericValue) ? value : numericValue.toFixed(2)
}

function normalizeLensIndexes (lensIndexes) {
  let normalised = []
  if (!lensIndexes) {
    return normalised
  }

  for (let i = 0; i < lensIndexes.length; i++) {
    let lensIndex = normalizeLensIndex(lensIndexes[i])
    if (lensIndex.length > 0 && normalised.indexOf(lensIndex) === -1) {
      normalised.push(lensIndex)
    }
  }
  return normalised
}

function cleanFileName (fileName) {
  return fileName.replace(/[^a-zA-Z0-9._-]/g, '_')
}

function uploadCampaignBanner (context) {
  if (!context.state.bannerFile) {
    return Promise.resolve({
      campaignImageUrl: '',
      campaignImageStoragePath: ''
    })
  }

  let fileName = Date.now() + '_' + cleanFileName(context.state.bannerFile.name)
  let storagePath = 'campaignBanners/' + fileName
  let storageRef = context.rootState.fbStorage.ref().child(storagePath)

  return storageRef.put(context.state.bannerFile).then(function (snapshot) {
    return snapshot.ref.getDownloadURL()
  }).then(function (downloadURL) {
    return {
      campaignImageUrl: downloadURL,
      campaignImageStoragePath: storagePath
    }
  })
}

const state = {
  availableOrderTypes: [],
  availableLensDesigns: [],
  availableLensIndexes: [],
  name: '',
  isDemo: false,
  description: '',
  campaignImageUrl: '',
  campaignImageStoragePath: '',
  bannerFile: null,
  totalPrizeMoney: 0,
  startDate: '',
  endDate: '',
  invoiceStartDate: '',
  invoiceEndDate: '',
  minimumInvoicePricePerPiece: 0,
  eligibleLenseDesigns: [],
  eligibleLensIndexes: [],
  eligibleOrderTypes: [],
  showModal: false,
  showCreateSuccessModal: false,
  showCreateFailedModal: false,

  // reward pools
  rm5Amount: 0,
  rm10Amount: 0,
  rm20Amount: 0,
  rm30Amount: 0,
  rm50Amount: 0,
  rm100Amount: 0,
  customRMAmount: [],
  sumOfAllNotes: 0,

  showValidationModal: false,
  validationMessage: ''
}

const mutations = {
  addOrderType: function (state, orderType) {
    state.availableOrderTypes.push(orderType)
    // console.log('state.availableOrderTypes:' + state.availableOrderTypes)
  },
  addLensDesign: function (state, lensDesign) {
    state.availableLensDesigns.push(lensDesign)
  },
  addLensIndex: function (state, lensIndex) {
    let normalisedLensIndex = normalizeLensIndex(lensIndex)
    if (normalisedLensIndex.length > 0 && state.availableLensIndexes.indexOf(normalisedLensIndex) === -1) {
      state.availableLensIndexes.push(normalisedLensIndex)
    }
  },
  updateCampaignStartDate: function (state, dateString) {
    // console.log('Updated campaign start date to: ' + dateString)
    let m = moment(dateString, 'DD/MM/YYYY hh:mm:ss')
    state.startDate = m
  },
  updateCampaignEndDate: function (state, dateString) {
    // console.log('Updated campaign end date to: ' + dateString)
    let m = moment(dateString, 'DD/MM/YYYY hh:mm:ss')
    state.endDate = m
  },
  updateInvoiceStartDate: function (state, dateString) {
    // console.log('Updated invoice start date to: ' + dateString)
    let m = moment(dateString, 'DD/MM/YYYY hh:mm:ss')
    state.invoiceStartDate = m
  },
  updateInvoiceEndDate: function (state, dateString) {
    // console.log('Updated invoice end date to: ' + dateString)
    let m = moment(dateString, 'DD/MM/YYYY hh:mm:ss')
    state.invoiceEndDate = m
  },
  updateName: function (state, newName) {
    state.name = newName
  },
  udpateIsDemo: function (state, isDemo) {
    state.isDemo = isDemo
  },
  updateDescription: function (state, newDescription) {
    state.description = newDescription
  },
  updateCampaignBannerFile: function (state, file) {
    state.bannerFile = file
  },
  updateTotalPrizeMoney: function (state, newTotalPrizeMoney) {
    state.totalPrizeMoney = newTotalPrizeMoney
  },
  updateMinimumInvoicePrice: function (state, newMinimum) {
    state.minimumInvoicePricePerPiece = newMinimum
  },
  updateEligibleLenseDesigns: function (state, newValues) {
    state.eligibleLenseDesigns = newValues
  },
  updateEligibleOrderTypes: function (state, newValues) {
    state.eligibleOrderTypes = newValues
  },
  updateEligibleLensIndexes: function (state, newValues) {
    state.eligibleLensIndexes = newValues
  },
  toggleShowModal: function (state, show) {
    state.showModal = show
  },
  toggleShowCreateSuccessModal: function (state, show) {
    state.showCreateSuccessModal = show
  },
  toggleShowCreateFailedModal: function (state, show) {
    state.showCreateFailedModal = show
  },
  toggleShowValidationModal: function (state, show) {
    state.showValidationModal = show
  },
  resetAllFields: function (state) {
    state.name = ''
    state.description = ''
    state.campaignImageUrl = ''
    state.campaignImageStoragePath = ''
    state.bannerFile = null
    state.totalPrizeMoney = 0
    state.startDate = ''
    state.endDate = ''
    state.invoiceStartDate = ''
    state.invoiceEndDate = ''
    state.minimumInvoicePricePerPiece = 0
    state.eligibleLenseDesigns = []
    state.eligibleLensIndexes = []
    state.eligibleOrderTypes = []
    state.rm5Amount = 0
    state.rm10Amount = 0
    state.rm20Amount = 0
    state.rm30Amount = 0
    state.rm50Amount = 0
    state.rm100Amount = 0
    state.customRMAmount = []
    state.sumOfAllNotes = 0
  },
  updateRm5Amount: function (state, newValue) {
    state.rm5Amount = Number(newValue)

    recalculateRewardPoolTotal(state)
  },
  updateRm10Amount: function (state, newValue) {
    state.rm10Amount = Number(newValue)

    recalculateRewardPoolTotal(state)
  },
  updateRm20Amount: function (state, newValue) {
    state.rm20Amount = Number(newValue)

    recalculateRewardPoolTotal(state)
  },
  updateRm30Amount: function (state, newValue) {
    state.rm30Amount = Number(newValue)

    recalculateRewardPoolTotal(state)
  },
  updateRm50Amount: function (state, newValue) {
    state.rm50Amount = Number(newValue)

    recalculateRewardPoolTotal(state)
  },
  updateRm100Amount: function (state, newValue) {
    state.rm100Amount = Number(newValue)

    recalculateRewardPoolTotal(state)
  },
  addCustomNote: function (state) {
    state.customRMAmount.push({
      rewardLabel: '',
      rewardType: 'VOUCHER',
      rewardValue: 0,
      totalQuantity: 0,
      noteType: 0,
      noteAmount: 0
    })
  },
  removeCustomNote: function (state, index) {
    state.customRMAmount.splice(index, 1)
    recalculateRewardPoolTotal(state)
  },
  updatedCustomNote: function (state) {
    recalculateRewardPoolTotal(state)
  }
}

const getters = {
  getName: function (state, getters, rootState) {
    return state.name
  },
  getDescription: function (state, getters, rootState) {
    return state.description
  },
  getTotalPrizeMoney: function (state, getters, rootState) {
    return state.totalPrizeMoney
  },
  getStartDate: function (state, getters, rootState) {
    let dateString = state.startDate.format('DD/MM/YYYY hh:mm:ss')
    return dateString
  },
  getEndDate: function (state, getters, rootState) {
    let dateString = state.endDate.format('DD/MM/YYYY hh:mm:ss')
    return dateString
  },
  getInvoiceStartDate: function (state, getters, rootState) {
    let dateString = state.invoiceStartDate.format('DD/MM/YYYY hh:mm:ss')
    return dateString
  },
  getInvoiceEndDate: function (state, getters, rootState) {
    let dateString = state.invoiceEndDate.format('DD/MM/YYYY hh:mm:ss')
    return dateString
  },
  getMinimumInvoicePricePerPiece: function (state, getters, rootState) {
    return state.minimumInvoicePricePerPiece
  },
  getEligibleLenseDesigns: function (state, getters, rootState) {
    return state.eligibleLenseDesigns
  },
  getEligibleOrderTypes: function (state, getters, rootState) {
    return state.eligibleOrderTypes
  },
  getAvailableLensDesigns: function (state, getters, rootState) {
    return state.availableLensDesigns
  },
  getAvailableLensIndexes: function (state, getters, rootState) {
    return state.availableLensIndexes
  },
  getAvailableOrderTypes: function (state, getters, rootState) {
    return state.availableOrderTypes
  }
}

const actions = {
  fetchAvailableOrderTypesFromFirestore (context) {
    context.state.availableOrderTypes = []

    let firstQuery = context.rootState.firestoreDB.collection('orderTypes').orderBy('orderType')
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(doc => {
        // console.log('fetched: ' + doc.data().orderType)
        context.commit('addOrderType', doc.data().orderType)
      })
    })
  },
  fetchAvailableLensDesignsFromFirestore (context) {
    context.state.availableLensDesigns = []

    let firstQuery = context.rootState.firestoreDB.collection('lensDesigns').orderBy('lensDesign')
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(doc => {
        // console.log('fetched: ' + doc.data().lensDesign)
        context.commit('addLensDesign', doc.data().lensDesign)
      })
    })
  },
  fetchAvailableLensIndexesFromFirestore (context) {
    context.state.availableLensIndexes = []

    let firstQuery = context.rootState.firestoreDB.collection('lensIndexes').orderBy('lensIndex')
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(doc => {
        context.commit('addLensIndex', doc.data().lensIndex)
      })
    })
  },
  createCampaignInFirebase (context) {
    // console.log('createCampaignInFirebase')
    // validations
    if (context.state.name.length < 1) {
      context.state.validationMessage = 'Campaign name cannot be empty'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (context.state.description.length < 1) {
      context.state.validationMessage = 'Campaign description cannot be empty'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (!context.state.startDate) {
      context.state.validationMessage = 'You need to set a CAMPAIGN START date'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (!context.state.endDate) {
      context.state.validationMessage = 'You need to set a CAMPAIGN END date'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (context.state.startDate >= context.state.endDate) {
      context.state.validationMessage = 'CAMPAIGN END date need to be LATER than CAMPAIGN START date'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (!context.state.invoiceStartDate) {
      context.state.validationMessage = 'You need to set the INVOICE START date'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (!context.state.invoiceEndDate) {
      context.state.validationMessage = 'You need to set the INVOICE END date'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (context.state.invoiceStartDate >= context.state.invoiceEndDate) {
      context.state.validationMessage = 'INVOICE END date need to be LATER than INVOICE START date'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (context.state.minimumInvoicePricePerPiece < 0) {
      context.state.validationMessage = 'Minimum invoice price per piece cannot be less than 0'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (context.state.eligibleLenseDesigns.length === 0) {
      context.state.validationMessage = 'Please select at least one eligible lense design'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (context.state.eligibleOrderTypes.length === 0) {
      context.state.validationMessage = 'Please select at least one eligible order type'
      context.commit('toggleShowValidationModal', true)
      return
    }
    if (context.state.eligibleLensIndexes.length === 0) {
      context.state.validationMessage = 'Please select at least one eligible lens index'
      context.commit('toggleShowValidationModal', true)
      return
    }
    // our pool of campaign rewards
    let notesPool = []
    for (let i = 0; i < context.state.customRMAmount.length; i++) {
      let reward = context.state.customRMAmount[i]
      let rewardLabel = getRewardLabel(reward)
      let rewardValue = getRewardValue(reward)
      let rewardQuantity = getRewardQuantity(reward)

      if (rewardQuantity > 0 && rewardLabel.length > 0) {
        notesPool.push({
          rewardId: rewardLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + '-' + i,
          rewardLabel: rewardLabel,
          rewardType: reward.rewardType || (rewardValue > 0 ? 'MONEY' : 'VOUCHER'),
          rewardValue: rewardValue,
          totalQuantity: rewardQuantity,
          claimedQuantity: 0,
          noteType: String(rewardValue),
          noteAmount: rewardQuantity,
          claimedAmount: 0
        })
      }
    }
    if (notesPool.length === 0) {
      context.state.validationMessage = 'Please specify at least one reward name and quantity'
      context.commit('toggleShowValidationModal', true)
      return
    }
    // validation ends

    // write to firestore starts
    context.commit('toggleShowModal', true)
    let campaignsCollection = context.rootState.firestoreDB.collection('campaigns')

    uploadCampaignBanner(context).then(function (bannerInfo) {
      let objToAdd = {
        name: context.state.name,
        demo: context.state.isDemo,
        description: context.state.description,
        campaignImageUrl: bannerInfo.campaignImageUrl,
        campaignImageStoragePath: bannerInfo.campaignImageStoragePath,
        totalPrizeMoney: Number(context.state.sumOfAllNotes),
        startDate: context.state.startDate.toDate(),
        endDate: context.state.endDate.toDate(),
        invoiceStartDate: context.state.invoiceStartDate.toDate(),
        invoiceEndDate: context.state.invoiceEndDate.toDate(),
        minimumPrice: context.state.minimumInvoicePricePerPiece,
        orderTypes: context.state.eligibleOrderTypes,
        lensDesigns: context.state.eligibleLenseDesigns,
        lensIndexes: normalizeLensIndexes(context.state.eligibleLensIndexes),
        status: 'NEW',
        createdDate: new Date(),
        createdBy: '',
        updatedDate: null,
        updatedBy: '',
        notesPool: notesPool
      }

      return campaignsCollection.add(objToAdd)
    }).then(function (docRef) {
      console.log('Created campaign')

      context.commit('resetAllFields')
      context.commit('toggleShowModal', false)
      context.commit('toggleShowCreateSuccessModal', true)
      context.commit('toggleShowValidationModal', false)
    }).catch(function (err) {
      console.error('Error creating campaign: ' + err)
      context.commit('resetAllFields')
      context.commit('toggleShowModal', false)
      context.commit('toggleShowCreateFailedModal', true)
      context.commit('toggleShowValidationModal', false)
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/createcampaignstoremodule.js